import axios from 'axios';

export const state = () => ({
    mutedKeywords: [],
    softChangeId: 0, // A trigger to subscribe when BE shouldn't be called for refreshing widgets
    hardChangeId: 0, // A trigger to subscribe when BE has to be called for refreshing widgets
});

export const getters = {
    mutedKeywords: state => state.mutedKeywords,
    mutedKeywordValues: state => state.mutedKeywords.map(keyword => keyword.value),
    softChangeId: state => state.softChangeId,
    hardChangeId: state => state.hardChangeId,
};

export const mutations = {
    SET_MUTED_KEYWORDS(state, mutedKeywords) {
        state.mutedKeywords = mutedKeywords;
    },

    ADD(state, mutedKeywords) {
        mutedKeywords.forEach(keyword => state.mutedKeywords.push(keyword));
    },

    REMOVE(state, mutedKeyword) {
        const index = state.mutedKeywords.findIndex(keyword => keyword.id === mutedKeyword);
        state.mutedKeywords.splice(index, 1);
    },

    TOGGLE_CHANGED(state) {
        state.changed = !state.changed;
    },

    COMMIT_CHANGE(state, softMode=true) {
        if (softMode) state.softChangeId += 1;
        else state.hardChangeId += 1;
    },
};

export const actions = {
    async index({ commit }) {
        const mutedKeywords = await axios.$get('/v1/muted_keywords/');

        commit('SET_MUTED_KEYWORDS', mutedKeywords);
    },

    async add({ commit, state }, mutedKeywords) {
        const splitedKeywords = mutedKeywords.map(keyword => keyword.split(' / '));
        const formattedMutedKeywords = splitedKeywords.flat().map(keyword => ({ value: keyword }));
        const mutedKeywordsWithoutDuplicating = formattedMutedKeywords.filter(keyword => {
            const duplicated = state.mutedKeywords.some(mutedKeyword => mutedKeyword.value === keyword.value);
            return !duplicated;
        });

        if (!mutedKeywordsWithoutDuplicating.length) {
            return;
        }

        const data = await axios.$post('/v1/muted_keywords', { mutedKeywords: mutedKeywordsWithoutDuplicating });

        commit('ADD', data);
        commit('COMMIT_CHANGE');
    },

    async remove({ commit }, mutedKeyword) {
        await axios.$delete(`/v1/muted_keywords/${mutedKeyword}`);
        commit('REMOVE', mutedKeyword);
        commit('COMMIT_CHANGE');
    },

    commitHardChange({ commit }) {
        commit('COMMIT_CHANGE', false);
    }
};
